var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-container",on:{"scroll":function($event){return _vm.handleScroll()}}},[_vm._t("default",null,{"isOffsetLeft":_vm.isOffsetLeft})],2)}
var staticRenderFns = []

export { render, staticRenderFns }